import React from 'react';
import './Sexuality.css';
import {Link} from '@reach/router';


  const sexuality =() =>{
    return ( <div class="sexualityhub">
      <h1> Sexuality Hub</h1>
      <div  class = "hubmenu">
 <p> <Link to="/sexualitytips">Tips </Link> </p>
 </div>

 <div  class = "hubmenu">
 <p> <Link to="/helplines">Helplines </Link> </p>
 </div>
 <div  class = "hubmenu">
 <p> <Link to="/glossary">Glossary </Link> </p>
 </div>
 <div  class = "hubmenu">
 <p> <Link to="/sexualityblog">Blogs </Link> </p>
 </div>
 </div>
    )
}



  export default sexuality;